import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Mechanism() {
  return <Section background="light" className="relative overflow-hidden" data-id="element-205">
      <FadeIn data-id="element-206">
        <div className="text-center mb-12" data-id="element-207">
          <span className="text-[#1B4332] font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-208">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-209">
            ECT + Semáforo del Dolor
          </h2>
          <p className="text-lg max-w-2xl mx-auto" data-id="element-210">
            Rodilla Sin Miedo está construido como un sistema simple para que
            sepas exactamente qué hacer.
          </p>
        </div>
      </FadeIn>

      {/* "Semáforo del dolor" image */}
      <FadeIn delay={0.1} data-id="element-211">
        <div className="mb-12 rounded-2xl overflow-hidden shadow-lg max-w-lg mx-auto" data-id="element-212">
          <img src="https://cdn.magicpatterns.com/uploads/sQGVMd8KFxfJLSme27FoRx/heylloyd-image-1770617029853.png" alt="Semáforo del dolor — avanzá sin recaídas" className="w-full h-auto object-cover" data-id="element-213" />
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-214">
        {/* Semáforo */}
        <FadeIn delay={0.2} className="bg-white p-8 rounded-2xl shadow-lg border border-[#D8F3DC]" data-id="element-215">
          <h3 className="text-2xl font-bold mb-6 text-[#1B4332] flex items-center" data-id="element-216">
            <span className="mr-3 text-3xl" data-id="element-217">🚦</span>
            Semáforo del Dolor
          </h3>
          <p className="mb-6 text-gray-600" data-id="element-218">
            Una regla práctica para decidir cuándo avanzar, cuándo ajustar y
            cuándo retroceder sin culpa.
          </p>

          <div className="space-y-4" data-id="element-219">
            <div className="flex items-center p-3 rounded-lg bg-green-50 border border-green-100" data-id="element-220">
              <div className="w-4 h-4 rounded-full bg-green-500 mr-3 shadow-sm shadow-green-500/50" data-id="element-221" />
              <span className="font-medium text-green-900" data-id="element-222">
                Verde: Avanzar (Seguro)
              </span>
            </div>
            <div className="flex items-center p-3 rounded-lg bg-yellow-50 border border-yellow-100" data-id="element-223">
              <div className="w-4 h-4 rounded-full bg-yellow-500 mr-3 shadow-sm shadow-yellow-500/50" data-id="element-224" />
              <span className="font-medium text-yellow-900" data-id="element-225">
                Amarillo: Ajustar (Precaución)
              </span>
            </div>
            <div className="flex items-center p-3 rounded-lg bg-red-50 border border-red-100" data-id="element-226">
              <div className="w-4 h-4 rounded-full bg-red-500 mr-3 shadow-sm shadow-red-500/50" data-id="element-227" />
              <span className="font-medium text-red-900" data-id="element-228">
                Rojo: Retroceder (Alto)
              </span>
            </div>
          </div>

          <p className="mt-6 text-sm font-medium text-center text-gray-500 italic" data-id="element-229">
            "Porque la mayoría no se rompe por hacer poco. Se rompe por hacer
            mal."
          </p>
        </FadeIn>

        {/* ECT */}
        <FadeIn delay={0.3} className="bg-white p-8 rounded-2xl shadow-lg border border-[#D8F3DC]" data-id="element-230">
          <h3 className="text-2xl font-bold mb-6 text-[#1B4332] flex items-center" data-id="element-231">
            <span className="mr-3 text-3xl" data-id="element-232">📈</span>
            Escalera de Carga (ECT)
          </h3>
          <p className="mb-6 text-gray-600" data-id="element-233">
            En vez de "metele", tenés niveles claros. Solo subís cuando el
            cuerpo lo aprueba.
          </p>

          <div className="relative pl-4 space-y-8 before:absolute before:left-0 before:top-2 before:bottom-2 before:w-0.5 before:bg-gray-200" data-id="element-234">
            <div className="relative" data-id="element-235">
              <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-[#1B4332] ring-4 ring-white" data-id="element-236" />
              <h4 className="font-bold text-[#1B4332]" data-id="element-237">Nivel 0</h4>
              <p className="text-sm text-gray-600" data-id="element-238">
                Calmar + activar sin irritar
              </p>
            </div>
            <div className="relative" data-id="element-239">
              <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-[#2D6A4F] ring-4 ring-white" data-id="element-240" />
              <h4 className="font-bold text-[#2D6A4F]" data-id="element-241">Nivel 1</h4>
              <p className="text-sm text-gray-600" data-id="element-242">
                Estabilidad básica para la vida diaria
              </p>
            </div>
            <div className="relative" data-id="element-243">
              <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-[#40916C] ring-4 ring-white" data-id="element-244" />
              <h4 className="font-bold text-[#40916C]" data-id="element-245">Nivel 2</h4>
              <p className="text-sm text-gray-600" data-id="element-246">
                Fuerza útil (silla, escalón bajo, caminata)
              </p>
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} className="mt-12 text-center" data-id="element-247">
        <Button size="lg" scrollTo="checkout" data-id="element-248">
          Quiero aplicar este sistema
        </Button>
      </FadeIn>
    </Section>;
}